import {Entity} from '../common/Entity';

export class SimpleDomain extends Entity {
  public title: string;
  public iconClass: string;
}
